module.exports = __webpack_public_path__ + "static/img/fs_hxjz.921e692.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fs_hxjz.png
// module id = rSzP
// module chunks = 0